export default "__VITE_ASSET__e740a734__"